import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

export default function PhotoLightbox({ isOpen, onClose, beforePhoto, afterPhoto, customerName }) {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="lightbox-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="photo-lightbox"
        >
          <motion.div
            className="lightbox-content"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={e => e.stopPropagation()}
          >
            <button className="lightbox-close" onClick={onClose} data-testid="lightbox-close">
              <X size={24} />
            </button>
            {customerName && <h3 className="lightbox-name">{customerName}</h3>}
            <div className="lightbox-photos">
              {beforePhoto && (
                <div className="lightbox-photo-col">
                  <span className="lightbox-label">Before</span>
                  <img src={beforePhoto} alt="Before" className="lightbox-img" />
                </div>
              )}
              {afterPhoto && (
                <div className="lightbox-photo-col">
                  <span className="lightbox-label">After</span>
                  <img src={afterPhoto} alt="After" className="lightbox-img" />
                </div>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
